import { DropdownCellEditor, DropdownCellRenderer } from './DropdownCellInnerComponents'
import { DataGridCell } from './types'

export const DropdownCell: DataGridCell = {
    provideRenderer: DropdownCellRenderer,
    provideEditor: DropdownCellEditor,
    popupEditor: true,
}
